export function formatTimecode(seconds, fps = 30) {
  const totalFrames = Math.floor(seconds * fps);
  const frames = totalFrames % fps;
  const totalSeconds = Math.floor(seconds);
  const secs = totalSeconds % 60;
  const mins = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 3600);
  return [
    String(hours).padStart(2, '0'),
    String(mins).padStart(2, '0'),
    String(secs).padStart(2, '0'),
    String(frames).padStart(2, '0'),
  ].join(':');
}

export function timecodeToSeconds(timecode, fps = 30) {
  const [h, m, s, f] = timecode.split(':').map(Number);
  return h * 3600 + m * 60 + s + f / fps;
}
